import { messageError } from '../../../../../../store/batchTicket/constants';

export const getOffersQuantityText = (offersQuantity?: number) => {
  if (!offersQuantity) {
    return messageError;
  }

  const quantityText = offersQuantity > 1 ? 'ativos' : 'ativo';

  return `${offersQuantity} ${quantityText}`;
};
